import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { PlayerContentItem, StationManagerService } from '@splixer/player';
import * as dayjs from 'dayjs';
import { nString } from '@hidat/huijs-common';
import { MediaContentType } from '@splixer/common';

/**
 * Displays the track info - name, artist, album, release date, label
 * Does NOT display album artwork.
 * If you don't want the startedAt date to display, don't pass it!
 */
@Component({
  selector: 'pv2-track-info',
  templateUrl: 'track-info.component.html',
  styleUrls: ['../player-v2-styles.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class Pv2TrackInfoComponent {
  public content = input<PlayerContentItem | undefined>();
  public startedAt = input<dayjs.Dayjs | undefined>();

  protected station = inject(StationManagerService);

  protected startedAtFormatted = computed(() => {
    let d: string | undefined;
    const sa = this.startedAt();
    if (sa) {
      d = this.station.formatTime(sa);
    }
    return d;
  });

  protected trackName = computed(() => {
    let name: nString;
    const cp = this.content();
    if (cp) {
      if (cp.contentType === MediaContentType.MicBreak) {
        name = 'Air Break';
      } else {
        name = cp.name;
      }
    }
    return name;
  });

  protected trackLabel = computed(() => {
    let name: nString;
    const cp = this.content();
    if (cp) {
      if (cp.releaseDate) {
        if (cp.releaseDate.length > 4) {
          name = cp.releaseDate.slice(0, 4);
        } else {
          name = cp.releaseDate;
        }
      }
      if (cp.labelName) {
        if (name) {
          name += ' - ' + cp.labelName;
        } else {
          name = cp.labelName;
        }
      }
    }
    return name;
  });
}
